import { Injectable } from '@angular/core';
import { ResponseData } from '../../nest-responses';
import { NestApiProvider } from '../../nest-api';
import { RequestUpdateTimezoneDto, ResponseGetTimezone } from '../dto/timezone.dto';
import { NestAuthProvider } from "../../nest-auth";

@Injectable()
export class TimezoneApi {

  private readonly service: string = '';
  private readonly model: string = 'timezone';

  constructor(
    private nestApiProvider: NestApiProvider,
    private nestAuth: NestAuthProvider
  ) {
  }

  public updateTimezoneEmployees(payload: RequestUpdateTimezoneDto) {
    const method: string = 'POST';
    const func: string = 'updateTimezoneEmployees';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public getAllTimezone() {
    const method: string = 'GET';
    const func: string = 'getAllTimezone';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseGetTimezone[]>>(method, url, params, urlParams, body);
  }

  public getTimezoneHistory() {
    const method: string = 'GET';
    const func: string = 'getTimezoneHistory';
    const params: any = {
      access_token: this.nestAuth.getAccessToken()
    };
    const urlParams: any = {
      access_token: this.nestAuth.getAccessToken()
    };
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/timezone.api.ts